import Scroll from './scroll'
import { connect } from 'react-redux'

import { setOffsetTop } from '../../../../common/actions/layout'

const mapStateToProps = (state, ownProps) => {
  const {
    layout: { selectedItem, offsetTop }
  } = state

  return {
    selected: selectedItem && selectedItem.id === ownProps.itemId,
    offsetTop
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setOffsetTop: offsetTop => {
      dispatch(setOffsetTop(offsetTop))
    }
  }
}

const ScrollContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Scroll)

export default ScrollContainer
